import { Button, ButtonsGroup } from '@billy/design-system'
import React from 'react'
import { useTranslation } from 'react-i18next'

export type NavigationButtonsProps = {
  color?: string
  disableLeftAction?: boolean
  disableRightAction?: boolean
  labelLeft?: string
  labelRight?: string
  onLeftClick?: () => void
  onRightClick?: () => void
  idLeft?: string
  idRight?: string
}

export const NavigationButtons = (props: NavigationButtonsProps) => {
  const { t } = useTranslation()
  const {
    disableLeftAction,
    disableRightAction,
    labelLeft = t('previous'),
    labelRight = t('skip'),
    onLeftClick = () => null,
    onRightClick = () => null,
    idLeft,
    idRight,
  } = props

  return (
    <ButtonsGroup>
      <Button
        data-id={idLeft}
        disabled={disableLeftAction}
        icon="chevronLeft"
        onClick={onLeftClick}
        size="md"
        variant="text"
      >
        {labelLeft}
      </Button>
      <Button
        data-id={idRight}
        disabled={disableRightAction}
        iconRight="chevronRight"
        onClick={onRightClick}
        size="md"
        variant="text"
      >
        {labelRight}
      </Button>
    </ButtonsGroup>
  )
}
